import { store } from '@/store'
import { NavigationGuardNext, Route } from 'vue-router'
import { getDeepLinkParams } from './router-helpers'

/**
 * Prevent navigation to routes that require a selected tenant
 */
export default (to: Route, from, next: NavigationGuardNext) => {
    //  Create a 'pass' function
    const pass = (why: string): void => {
        store.getters.appDebug && console.log(`GUARD: multi-tenant-guard pass. (${why})`)
        return next('/inbox')
    }

    //  Create a 'fail' function
    const fail = (why: string): void => {
        store.getters.appDebug && console.log(`GUARD: multi-tenant-guard fail. (${why})`)
        //  Just stay put
        return next()
    }

    //  Fetch the current auth user
    const user = store.getters.user

    //  If the user is a reseller then fail
    if (user.reseller) return fail('reseller')

    //  Get the number of memberships for our auth user
    const memberships = user.memberships

    //  Check how many memberships the user has
    const total = memberships.length

    //  If they have more than 1 then fail (leave them there)
    if (total > 1) return fail('multiple tenants')

    //  Else, they only have 1 so lets grab that tenant
    const tenantId = memberships[0].tenant_id

    //  Else, fetch the storage tenant id
    store.dispatch('tenantGet', tenantId).then(tenant => {

        //  If the tenant does NOT exist, remove tenant from sessionStorage
        if (!tenant) {
            store.commit('tenantSet', null)
            return fail('tenant not found')
        }

        //  Else, tenant was loaded, guard passes
        return pass(`tenant loaded`)
    })
}
